import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import unidecode from "unidecode"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const EMOJI_RE = /\p{Extended_Pictographic}/gu;
// Variation selectors/joiners/keycaps/skin tones must be removed too, otherwise
// the transliterator maps the orphaned codepoints to "[?]".
// eslint-disable-next-line no-misleading-character-class
const EMOJI_SCRAP_RE = /[\uFE0E\uFE0F\u20E3\u200D\u{1F3FB}-\u{1F3FF}]/gu;

export function toAscii(text: string): string {
  if (!text) return text;
  const stripped = unidecode(text.replace(EMOJI_RE, "").replace(EMOJI_SCRAP_RE, ""));
  return [...stripped].filter((ch) => ch.charCodeAt(0) < 128).join("");
}

/**
 * Converts a plain text string with @mentions into an HTML string
 * that Tiptap can use to render its Mention nodes.
 * @param text The plain text input.
 * @returns An HTML string with mentions wrapped in Tiptap-specific spans.
 */
export function plainTextToMentionHtml(text: string): string {
  // This regex finds @ followed by one or more word characters or hyphens.
  const mentionRegex = /@([\w-]+)/g;
  
  // Replace each mention with the required Tiptap HTML structure.
  // We need to escape the HTML to prevent it from being rendered as raw HTML inside the editor's code view.
  const html = text.replace(mentionRegex, (match, mentionId) => {
    return `<span data-type="mention" data-id="${mentionId}">${match}</span>`;
  });

  return html;
}
